import news from "fragments/news/news"
import gql from "graphql-tag"

const GET_DRAFTS_NEWS_WAVE = gql`
  ${news}

  query getDraftsNewsWave($cursor: String) {
    draftsNewsWave(cursor: $cursor) {
      cursor
      hasNextData
      hasPrevData
      news {
        ...News
      }
      prevCursor
    }
  }
`
export default GET_DRAFTS_NEWS_WAVE
